import { AcquisitionSourceOption } from "@core/models";

export const ACQUISITION_SOURCES: AcquisitionSourceOption[] = [
  { value: 'redes_sociales', label: 'Redes sociales' },
  { value: 'pagina_web', label: 'Página web' },
  { value: 'referido', label: 'Referido' },
  { value: 'google_maps', label: 'Google Maps' },
  { value: 'otro', label: 'Otro' },
] as const;
